export let hress5uColumns = () => {
  let indexColumns = [
    {
      key: 'codempid',
      name: '',
      labelCodapp: 'HRESS5UC1',
      labelIndex: '40',
      class: 'align-center',
      style: 'min-width: 100px;'
    }, {
      key: 'desc_codempid',
      name: '',
      labelCodapp: 'HRESS5UC1',
      labelIndex: '50',
      style: 'min-width: 200px;'
    }, {
      key: 'dtereq',
      name: '',
      labelCodapp: 'HRESS5UC1',
      labelIndex: '30',
      class: 'align-center',
      style: 'min-width: 120px;',
      dataType: 'date'
    }, {
      key: 'numseq',
      name: '',
      labelCodapp: 'HRESS5UC1',
      labelIndex: '35',
      class: 'align-center',
      style: 'min-width: 100px;'
    }, {
      key: 'desc_codpos_temploy1',
      name: '',
      labelCodapp: 'HRESS5UC1',
      labelIndex: '60',
      style: 'min-width: 200px;'
    }, {
      key: 'desc_codpos',
      name: '',
      labelCodapp: 'HRESS5UC1',
      labelIndex: '70',
      style: 'min-width: 200px;'
    }, {
      key: 'desc_codcomp',
      name: '',
      labelCodapp: 'HRESS5UC1',
      labelIndex: '80',
      style: 'min-width: 200px;'
    }, {
      key: 'status',
      name: '',
      labelCodapp: 'HRESS5UC1',
      labelIndex: '90',
      style: 'min-width: 200px;'
    }, {
      key: 'desc_codappr',
      name: '',
      labelCodapp: 'HRESS5UC1',
      labelIndex: '100',
      style: 'min-width: 200px;'
    }, {
      key: 'dteappr',
      name: '',
      labelCodapp: 'HRESS5UC1',
      labelIndex: '110',
      class: 'align-center',
      style: 'min-width: 120px;',
      dataType: 'date'
    }, {
      key: 'remark',
      name: '',
      labelCodapp: 'HRESS5UC1',
      labelIndex: '120',
      style: 'min-width: 200px;'
    }, {
      key: 'desc_codempap',
      name: '',
      labelCodapp: 'HRESS5UC1',
      labelIndex: '130',
      style: 'min-width: 200px;'
    }
  ]
  let detailTab2Columns = [
    {
      key: 'desc_codcomp',
      name: '',
      labelCodapp: 'HRESS5UC4',
      labelIndex: '20',
      style: 'min-width: 200px;'
    }, {
      key: 'desc_codpos',
      name: '',
      labelCodapp: 'HRESS5UC4',
      labelIndex: '30',
      style: 'min-width: 200px;'
    }, {
      key: 'desc_codjob',
      name: '',
      labelCodapp: 'HRESS5UC4',
      labelIndex: '40',
      style: 'min-width: 200px;'
    }, {
      key: 'qtyreq',
      name: '',
      labelCodapp: 'HRESS5UC4',
      labelIndex: '50',
      class: 'align-center',
      style: 'min-width: 120px;'
    }, {
      key: 'dteopen',
      name: '',
      labelCodapp: 'HRESS5UC4',
      labelIndex: '60',
      class: 'align-center',
      style: 'min-width: 200px;',
      dataType: 'date'
    }, {
      key: 'dteclose',
      name: '',
      labelCodapp: 'HRESS5UC4',
      labelIndex: '70',
      class: 'align-center',
      style: 'min-width: 200px;',
      dataType: 'date'
    }, {
      key: 'quality',
      name: '',
      labelCodapp: 'HRESS5UC4',
      labelIndex: '0',
      class: 'align-center',
      style: 'min-width: 120px;',
      eventName: 'quality',
      eventIcon: 'file-text'
    }, {
      key: 'jobDescription',
      name: '',
      labelCodapp: 'HRESS5UP1',
      labelIndex: '0',
      class: 'align-center',
      style: 'min-width: 120px;',
      eventName: 'jobDescription',
      eventIcon: 'file-text'
    }
  ]
  let detailTab2Popup2Tab2Columns = [
    {
      key: 'itemno',
      name: '',
      labelCodapp: 'HRESS5UP2',
      labelIndex: '20',
      class: 'align-center',
      style: 'min-width: 100px;'
    }, {
      key: 'namitem',
      name: '',
      labelCodapp: 'HRESS5UP2',
      labelIndex: '30',
      style: 'min-width: 200px;'
    }, {
      key: 'descrip',
      name: '',
      labelCodapp: 'HRESS5UP2',
      labelIndex: '40',
      style: 'min-width: 200px;'
    }
  ]
  let detailTab2Popup2Tab3Columns = [
    {
      key: 'itemno',
      name: '',
      labelCodapp: 'HRESS5UP2',
      labelIndex: '20',
      class: 'align-center',
      style: 'min-width: 100px;'
    }, {
      key: 'namitem',
      name: '',
      labelCodapp: 'HRESS5UP2',
      labelIndex: '30',
      style: 'min-width: 200px;'
    }, {
      key: 'descrip',
      name: '',
      labelCodapp: 'HRESS5UP2',
      labelIndex: '40',
      style: 'min-width: 200px;'
    }
  ]
  let detailTab2Popup2Tab4Columns = [
    {
      key: 'seqno',
      name: '',
      labelCodapp: 'HRESS5UP5',
      labelIndex: '20',
      class: 'align-center',
      style: 'min-width: 80px;'
    }, {
      key: 'codedlv',
      name: '',
      labelCodapp: 'HRESS5UP5',
      labelIndex: '30',
      class: 'align-center',
      style: 'min-width: 100px;'
    }, {
      key: 'desc_codedlv',
      name: '',
      labelCodapp: 'HRESS5UP5',
      labelIndex: '40',
      style: 'min-width: 200px;'
    }, {
      key: 'codmajsb',
      name: '',
      labelCodapp: 'HRESS5UP5',
      labelIndex: '50',
      class: 'align-center',
      style: 'min-width: 100px;'
    }, {
      key: 'desc_codmajsb',
      name: '',
      labelCodapp: 'HRESS5UP5',
      labelIndex: '60',
      style: 'min-width: 200px;'
    }, {
      key: 'numgpa',
      name: '',
      labelCodapp: 'HRESS5UP5',
      labelIndex: '70',
      class: 'align-center',
      style: 'min-width: 100px;'
    }
  ]

  return {
    en: {
      index: indexColumns,
      detailTab2: detailTab2Columns,
      detailTab2Popup2Tab2: detailTab2Popup2Tab2Columns,
      detailTab2Popup2Tab3: detailTab2Popup2Tab3Columns,
      detailTab2Popup2Tab4: detailTab2Popup2Tab4Columns
    },
    th: {
      index: indexColumns,
      detailTab2: detailTab2Columns,
      detailTab2Popup2Tab2: detailTab2Popup2Tab2Columns,
      detailTab2Popup2Tab3: detailTab2Popup2Tab3Columns,
      detailTab2Popup2Tab4: detailTab2Popup2Tab4Columns
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/columns/hress5u.js